import { render, staticRenderFns } from "./VetClaimCorrespondenceList.vue?vue&type=template&id=76f3511a&"
import script from "./VetClaimCorrespondenceList.vue?vue&type=script&lang=js&"
export * from "./VetClaimCorrespondenceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports